import './SelectableFilterView.less';
import React from "react";
import arrayToStringWithCount from "../../config/arrayToStringWithCount";
import FilterViewTemplate from "../../templates/filter-view/FilterViewTemplate";


export default class SelectableFilterView extends React.Component {
    getOperator = () => {
        const {optSingle} = this.props;

        if (optSingle) {
            return 'is';
        }

        return 'in_list';
    };

    render() {
        const {fieldName, value, requestEdit, optSingle} = this.props;
        /** @type {LabelMap} */
        const options = this.props.options;
        const selectionsText = optSingle
            ? options.get(value).label
            : arrayToStringWithCount(options.items.filter(item => value.includes(item.value)).map(option => option.label));

        return <div className="selectable-filter-view">
            <FilterViewTemplate
                fieldName={fieldName}
                operator={this.getOperator()}
                value={selectionsText}
                valueLabel={selectionsText}
                requestEdit={requestEdit}
            />
        </div>;
    }
}
